import React from 'react'
import { Chip, makeStyles, Theme } from '@material-ui/core'

import {
    AUDIT_KIND_CHIPS,
    AuditKindChipKey,
    eventMatchesKindKeys,
} from './trailKinds'

const useStyles = makeStyles((theme: Theme) => ({
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.75),
        padding: theme.spacing(1.5, 2, 0),
    },
}))

interface TrailKindFilterProps {
    eventKinds: string[]
    selected: AuditKindChipKey[]
    onChange: (next: AuditKindChipKey[]) => void
}

export const TrailKindFilter = ({
    eventKinds,
    selected,
    onChange,
}: TrailKindFilterProps) => {
    const classes = useStyles()
    const chips = AUDIT_KIND_CHIPS.filter((chip) => {
        const present = eventKinds.some((kind) =>
            eventMatchesKindKeys(kind, [chip.key]),
        )
        return present || selected.includes(chip.key)
    })
    if (chips.length === 0) return null

    const toggle = (key: AuditKindChipKey) => {
        if (selected.includes(key)) {
            onChange(selected.filter((item) => item !== key))
            return
        }
        onChange([...selected, key])
    }

    return (
        <div className={classes.row}>
            {chips.map((chip) => {
                const active = selected.includes(chip.key)
                return (
                    <Chip
                        key={chip.key}
                        size="small"
                        clickable
                        color={active ? 'primary' : 'default'}
                        variant={active ? 'default' : 'outlined'}
                        label={chip.label}
                        onClick={() => toggle(chip.key)}
                        style={{ fontWeight: 600 }}
                    />
                )
            })}
        </div>
    )
}
